import React from 'react';
import { Link } from 'react-router-dom';
import { IMAGES } from '../constants/images';

const About = () => {
  return (
    <div data-testid="about-page">
      {/* Hero */}
      <section className="min-h-[60vh] bg-white flex items-center">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-32">
          <div className="max-w-3xl">
            <p 
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '11px',
                letterSpacing: '0.2em',
                color: '#555',
                marginBottom: '24px',
                textTransform: 'uppercase',
              }}
            >
              ABOUT PLUMO
            </p>
            <h1 
              className="font-handwritten"
              style={{
                fontSize: 'clamp(48px, 6vw, 80px)',
                color: '#1A1814',
                lineHeight: 1.1,
              }}
            >
              The things worth carrying.
            </h1>
          </div>
        </div>
      </section>

      {/* Manifesto */}
      <section className="bg-plumo-bone py-20 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
            {/* Image */}
            <div className="aspect-[4/5] bg-white overflow-hidden">
              <img
                src={IMAGES.editorial.about}
                alt="Editorial fashion"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Text */}
            <div className="lg:py-12">
              <p 
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: 400,
                  fontSize: 'clamp(18px, 2vw, 22px)',
                  color: '#0D0D0B',
                  lineHeight: 1.7,
                }}
              >
                Some things you reach for without thinking. The ring you put on before you leave. The bag that goes with everything and nothing. The weight of gold on your wrist at 2am.
              </p>
              <p 
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '14px',
                  fontWeight: 400,
                  color: '#0D0D0B',
                  lineHeight: 1.6,
                  marginTop: '32px',
                }}
              >
                Plumo is for those objects. The ones that don't explain themselves.
              </p>
              <p 
                className="font-handwritten"
                style={{
                  fontSize: '28px',
                  color: '#C9A961',
                  marginTop: '48px',
                }}
              >
                the things worth carrying.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values - UPDATE 2: Inter font for headers and body */}
      <section className="bg-white py-20 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          {/* "What we believe" - Inter, 32px, weight 600 */}
          <h2 
            style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: 600,
              fontSize: 'clamp(24px, 3vw, 32px)',
              color: '#0D0D0B',
              marginBottom: '48px',
              letterSpacing: '-0.01em',
            }}
          >
            What we believe
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {/* Value 1 */}
            <div className="border-t border-black/10 pt-8">
              {/* Number label - Inter, 12px, weight 500, uppercase */}
              <span 
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '12px',
                  fontWeight: 500,
                  letterSpacing: '0.2em',
                  color: '#0D0D0B',
                  textTransform: 'uppercase',
                }}
              >
                01
              </span>
              {/* Belief headline - Inter, 18px, weight 600 */}
              <h3 
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: 600,
                  fontSize: '18px',
                  color: '#0D0D0B',
                  marginTop: '16px',
                  marginBottom: '12px',
                  letterSpacing: '-0.005em',
                }}
              >
                Carry less. Mean more.
              </h3>
              {/* Body - Inter, 14px, weight 400 */}
              <p 
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '14px',
                  fontWeight: 400,
                  color: '#0D0D0B',
                  lineHeight: 1.6,
                }}
              >
                Everything here was chosen because it earns its place. Nothing decorative. Nothing disposable.
              </p>
            </div>

            {/* Value 2 */}
            <div className="border-t border-black/10 pt-8">
              <span 
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '12px',
                  fontWeight: 500,
                  letterSpacing: '0.2em',
                  color: '#0D0D0B',
                  textTransform: 'uppercase',
                }}
              >
                02
              </span>
              <h3 
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: 600,
                  fontSize: '18px',
                  color: '#0D0D0B',
                  marginTop: '16px',
                  marginBottom: '12px',
                  letterSpacing: '-0.005em',
                }}
              >
                Gold is the only language.
              </h3>
              <p 
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '14px',
                  fontWeight: 400,
                  color: '#0D0D0B',
                  lineHeight: 1.6,
                }}
              >
                We don't do silver. We don't do trends. We do one material, done right, at a price that doesn't punish you for having taste.
              </p>
            </div>

            {/* Value 3 */}
            <div className="border-t border-black/10 pt-8">
              <span 
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '12px',
                  fontWeight: 500,
                  letterSpacing: '0.2em',
                  color: '#0D0D0B',
                  textTransform: 'uppercase',
                }}
              >
                03
              </span>
              <h3 
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: 600,
                  fontSize: '18px',
                  color: '#0D0D0B',
                  marginTop: '16px',
                  marginBottom: '12px',
                  letterSpacing: '-0.005em',
                }}
              >
                Worn in. Not out.
              </h3>
              <p 
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '14px',
                  fontWeight: 400,
                  color: '#0D0D0B',
                  lineHeight: 1.6,
                }}
              >
                These pieces get better with time. The tarnish that isn't tarnish. The scratch that's actually a story.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA - UPDATE 2: Inter for header and link */}
      <section className="bg-plumo-bone py-20 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 text-center">
          {/* "Ready to carry..." - Inter, 32px, weight 600 */}
          <h2 
            style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: 600,
              fontSize: 'clamp(24px, 4vw, 32px)',
              color: '#0D0D0B',
              marginBottom: '24px',
              letterSpacing: '-0.01em',
            }}
          >
            Ready to carry something worth it?
          </h2>
          {/* "browse the collection" - Inter, 14px, weight 500 */}
          <Link
            to="/shop"
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '14px',
              fontWeight: 500,
              letterSpacing: '0.08em',
              color: '#0D0D0B',
              textDecoration: 'underline',
              textUnderlineOffset: '4px',
            }}
            className="hover:opacity-60 transition-opacity"
            data-testid="about-shop-link"
          >
            browse the collection
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
